import React from "react";
import "./Profile.css";
import { Form } from "react-bootstrap";
import Start_Btn from "../common/start-btn/Start_Btn";
import Common_Title from "../common/common-title/Common_Title";
import { useNavigate } from "react-router-dom";
import { AuthLogOut } from "../../features/auth/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAllReport, Getprofile, editprofile } from "../../redux/profile";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import Success_Modal from "../modals/success-modal/Success_Modal";
import { APIS } from "../../utils/APIS";
import { RegxExpression } from "../../utils/common";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller } from "react-hook-form";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [err, setErr] = React.useState(false);

  const getprofile = useSelector((state) => state?.profile?.getprofile);
  const getReports = useSelector(
    (state) => state?.profile?.getReportData?.reportData,
  );

  useEffect(() => {
    const token = Cookies.get("excellent_website_security");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      contact_no: "",
      dob: "",
      email: "",
      occupation: "",
      education_details: "",
    },
  });

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    dispatch(Getprofile());
    dispatch(GetAllReport());
  }, [dispatch]);

  useEffect(() => {
    if (getprofile) {
      const dobRaw = getprofile?.user?.dob;
      reset({
        first_name: getprofile?.user?.first_name || "",
        contact_no: getprofile?.user?.contact_no || "",
        // ✅ Normalize to Date (or null) so DatePicker + validator always get a Date
        dob: dobRaw ? new Date(dobRaw) : null,
        email: getprofile?.user?.email || "",
        occupation: getprofile?.user?.occupation || "",
        education_details: getprofile?.user?.education_details || "",
      });
    }
  }, [getprofile, reset]);

  const handleLogout = async () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (!confirmLogout) return;
    try {
      await dispatch(AuthLogOut()).unwrap();
    } catch (e) {
      console.error("Logout failed:", e);
    }
    // Show logout success popup, then redirect home
    setLogoutMsg("Logged out successfully");
    setShowLogoutModal(true);
    if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
    logoutTimeoutRef.current = setTimeout(() => {
      setShowLogoutModal(false);
      navigate("/");
    }, 1500);
  };

  const handleLogoutModalClose = () => {
    if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
    setShowLogoutModal(false);
    navigate("/");
  };

  const [showModal, setShowModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logoutMsg, setLogoutMsg] = useState("Logged out successfully");
  const logoutTimeoutRef = useRef(null);

  useEffect(
    () => () => {
      if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
    },
    [],
  );

  const onSubmit = async (data) => {
    setErr("");

    const userId = getprofile?.user?.id || getprofile?.user?._id;

    if (!userId) {
      console.error("User ID not found");
      return;
    }

    try {
      // ✅ Send dob as YYYY-MM-DD string (backend-safe) even though form holds a Date
      const payload = {
        ...data,
        dob:
          data?.dob instanceof Date
            ? data.dob.toISOString().split("T")[0]
            : data?.dob || "",
      };
      const res = await dispatch(
        editprofile({ id: userId, data: payload }),
      ).unwrap();

      if (res?.success) {
        setShowModal(true);
        setTimeout(() => {
          setShowModal(false);
          // navigate("/");
          navigate(-1);
        }, 2000);
      } else {
        setShowModal(true);
      }
    } catch (err) {
      console.error("Update failed:", err);

      // ✅ Backend validation errors
      setErr(err?.errors || err?.message);

      const message = err?.message?.toLowerCase() || "";

      // 🔥 Email duplicate
      if (message.includes("email")) {
        setError("email", {
          type: "manual",
          message: "Email already exists",
        });
      }

      // 🔥 Contact duplicate
      if (message.includes("contact")) {
        setError("contact_no", {
          type: "manual",
          message: "Contact number already exists",
        });
      }
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);

    const day = d.getDate();
    const month = d.toLocaleString("en-US", { month: "long" });
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = d
      .getMinutes()
      .toString()
      .padStart(2, "0");

    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12 || 12;

    return `${day} ${month} ${year} ${hours}:${minutes}${ampm}`;
  };
  return (
    <section className="Profile Book_A_Session">
      <div className="container">
        <div className="profile_title">
          <h5>
            {" "}
            Hi <span>{getprofile?.user?.first_name}</span>{" "}
          </h5>
        </div>

        <div className="Booking_Form_div">
          <Form className="custom_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {/* Full Name */}
              <div className="col-lg-6 col-md-4 col-12 mb-3">
                <Form.Group controlId="fullName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("first_name", {
                      required: "Name is required",
                      maxLength: {
                        value: 30,
                        message: "Full Name cannot exceed 30 characters",
                      },
                    })}
                    isInvalid={!!errors?.first_name}
                    placeholder="Enter full Name"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.first_name?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* Phone Number */}
              <div className="col-lg-4 col-md-4 col-sm-6 mb-3">
                <Form.Group controlId="phoneNumber">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="tel" // ✅ better than text
                    maxLength={10} // ✅ restrict length
                    placeholder="Enter Phone Number"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    {...register("contact_no", {
                      required: "Contact number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter valid 10 digit phone number",
                      },
                      minLength: {
                        value: 10,
                      },
                    })}
                    isInvalid={!!errors?.contact_no}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors?.contact_no?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* DOB */}
              <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                <Form.Group controlId="age">
                  <Form.Label>Date of Birth</Form.Label>
                  {/* <Form.Control
                    type="date"
                    {...register("dob", {
                      required: "Date of birth is required",
                      validate: (value) => {
                        const today = new Date();
                        const dob = new Date(value);

                        // ✅ Check valid date format & 4-digit year
                        const year = value?.split("-")[0];
                        if (!/^\d{4}$/.test(year)) {
                          return "Year must be 4 digits";
                        }

                        if (dob > today) return "Future date not allowed";

                        const age = today.getFullYear() - dob.getFullYear();
                        const m = today.getMonth() - dob.getMonth();

                        const finalAge =
                          m < 0 || (m === 0 && today.getDate() < dob.getDate())
                            ? age - 1
                            : age;

                        return (
                          finalAge >= 18 || "You must be at least 18 years old"
                        );
                      },
                    })}
                    isInvalid={!!errors?.dob}
                  /> */}

                  {/* DOb Changed */}

                  <Form.Group controlId="dob">
                    {/* <Form.Label>Date of Birth</Form.Label> */}

                    <Controller
                      name="dob"
                      control={control}
                      rules={{
                        required: "Date of birth is required",
                        validate: (value) => {
                          if (!value) return "Date of birth is required";

                          const dob =
                            value instanceof Date ? value : new Date(value);

                          if (isNaN(dob.getTime()))
                            return "Please enter a valid date";

                          const today = new Date();
                          today.setHours(23, 59, 59, 999);

                          return dob <= today || "Future date is not allowed";
                        },
                      }}
                      render={({ field }) => (
                        <DatePicker
                          selected={field.value ? new Date(field.value) : null}
                          onChange={(date) => field.onChange(date)}
                          onBlur={field.onBlur}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select Date of Birth"
                          minDate={new Date(1900, 0, 1)}
                          maxDate={new Date()} // Disable future dates
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={100}
                          scrollableYearDropdown
                          className={`form-control ${
                            errors?.dob ? "is-invalid" : ""
                          }`}
                          wrapperClassName="w-100"
                        />
                      )}
                    />

                    {errors?.dob && (
                      <div className="invalid-feedback d-block">
                        {errors.dob.message}
                      </div>
                    )}
                  </Form.Group>

                  {/* <Form.Control
                    type="date"
                    min="1900-01-01"
                    max={new Date().toISOString().split("T")[0]}
                    {...register("dob", {
                      required: "Date of birth is required",
                      validate: (value) => {
                        if (!value) return "Date of birth is required";

                        const regex = /^\d{4}-\d{2}-\d{2}$/;
                        if (!regex.test(value)) return "Invalid date format";

                        const [year, month, day] = value.split("-").map(Number);

                        if (year < 1000 || year > 9999) {
                          return "Year must be exactly 4 digits";
                        }

                        const today = new Date();
                        const dob = new Date(value);

                        if (dob > today) return "Future date not allowed";

                        const age = today.getFullYear() - year;
                        const m = today.getMonth() - (month - 1);

                        const finalAge =
                          m < 0 || (m === 0 && today.getDate() < day)
                            ? age - 1
                            : age;

                        return (
                          finalAge >= 18 || "You must be at least 18 years old"
                        );
                      },
                    })}
                    isInvalid={!!errors?.dob}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.dob?.message}
                  </Form.Control.Feedback> */}
                </Form.Group>
              </div>
            </div>

            <div className="row">
              {/* Email */}
              <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                <Form.Group controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: RegxExpression.email,
                        // value: /^[A-Za-z0-9](?:[A-Za-z0-9.+]*[A-Za-z0-9])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                        message: "Please enter a valid email",
                      },
                    })}
                    isInvalid={!!errors?.email}
                    placeholder="Enter Email"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.email?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* Occupation */}
              <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                <Form.Group controlId="currentOccupation">
                  <Form.Label>Current Occupation</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("occupation", {
                      required: "Occupation is required",
                      maxLength: {
                        value: 40,
                        message:
                          "Current occupation cannot exceed 40 characters",
                      },
                    })}
                    isInvalid={!!errors?.occupation}
                    placeholder="eg. Student"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.occupation?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              {/* Education */}
              <div className="col-12 mb-3">
                <Form.Group controlId="educationDetails">
                  <Form.Label>Education Details</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    {...register("education_details", {
                      required: "Education details are required",
                      minLength: {
                        value: 10,
                        message: "Enter at least 10 characters",
                      },
                      maxLength: {
                        value: 300,
                        message:
                          "Current occupation cannot exceed 300 characters",
                      },
                    })}
                    isInvalid={!!errors?.education_details}
                    className="education-textarea"
                    placeholder="Please provide accurate info..."
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.education_details?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <div className="edit_btn">
              <Start_Btn
                text="Save Details"
                type="submit" // ✅ IMPORTANT
              />
            </div>
          </Form>
        </div>

        {/* My Reports  */}

        {/* <div className="my_report_div">
          <Common_Title title="My Reports" />

          <div className="download_section">
            <div className="row">
              {getReports?.map((file) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-12 mb-4 download_col"
                  key={file?.id}
                >
                  <div className="file_card">
                    <div className="file_info">
                      <div className="pdf_icon_div">
                        <img
                          src="/assets/images/profile/pdf-icon.png"
                          alt="pdf"
                          className="pdf_icon"
                        />
                      </div>

                      <div className="flie_text_holder d-flex justify-content-between align-items-center">
                        <div className="file_text">
                          <p className="file_name mb-1">
                            {file.User_Exam?.exam_no}
                          </p>

                          <span className="file_date">
                            {formatDate(file.createdAt)}
                          </span>
                        </div>
                      </div>

                      <div className="">
                        <span
                          className="file_date fw-bold"
                          style={{
                            color: file?.pass_fail === "Pass" ? "green" : "red",
                          }}
                        >
                          {file?.pass_fail}
                        </span>
                      </div>
                    </div>

                    <div className="edit_btn">
                    

                      <Start_Btn
                        text="Download"
                        onClick={() =>
                          window.open(
                            `${process.env.REACT_APP_BASE_URL}${APIS.Test.downloadReport}/${file.id}`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        <div className="logout_btn_div">
          {/* <button className="logout_btn" onClick={() => navigate("/")}> Logout</button> */}
          <button className="logout_btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
      <Success_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
        message={"Successful"}
      />
      <Success_Modal
        show={showLogoutModal}
        handleClose={handleLogoutModalClose}
        message={logoutMsg}
      />
    </section>
  );
};

export default Profile;
